// Presentation only: the authenticated identity is already bound by createGame.
export function studentAlias(scene) {
  const alias = scene.registry.get('studentIdentity')?.alias;
  return typeof alias === 'string' ? alias.replace(/\s+/g, ' ').trim() : '';
}

export function fitStudentName(node, maxWidth) {
  const characters = Array.from(node.text);
  while (node.width > maxWidth && characters.length) {
    characters.pop();
    node.setText(`${characters.join('')}…`);
  }
  return node;
}
